import { EDuration, ETariffType, INormalizedTariff } from 'types';

import { DEFAULT_PRICE_LIST_VALUE } from './PriceList/PriceList';

const DEFAULT_VALUES: INormalizedTariff = {
  title: '',
  type: ETariffType.FIXED,
  is_active: true,
  duration: '',
  duration_type: EDuration.hours,
  lifetime: '',
  lifetime_type: EDuration.hours,
  price_list: [DEFAULT_PRICE_LIST_VALUE],
  days: [],
  hours: {
    start: '',
    end: '',
  },
  sales_hours: {
    start: '',
    end: '',
  },
  use_global_discounts: false,
  show_in_shell: true,
  show_in_billing: true,
  highlighted: false,
  ean: '',
  is_tracked: false,
  use_on_holidays: false,
  sort: 0,
  online_booking_enabled: false,
  disable_sale_receipt_printing: false,
};
const BOOKABLE_TARIFFS: Array<ETariffType> = [
  ETariffType.FIXED,
  ETariffType.PACKET,
  ETariffType.PER_MINUTE,
];

export { DEFAULT_VALUES, BOOKABLE_TARIFFS };
